import { BackGLBInfo, BackMorphsData } from '@types'

export default function getMorphsFromGLB(backGLBInfo: BackGLBInfo) {
  const morphs = backGLBInfo?.morphs
  if (morphs) {
    const foundMorphs = new Set(['Alto', 'Ancho', 'Fondo'])
    const morphed = morphs.map((el: BackMorphsData) => {
      foundMorphs.delete(el.nombre)
      return {
        default: el.valor,
        _default: el.valor,
        morphId: el.idMorph,
        order: el.orden,
        type: el.tipo,
        min: el.valorMin,
        max: el.valorMax,
        name: el.nombre,
        show: true,
        modifyable: true,
      }
    })

    // Agregar morph de Regleta si existe en backGLBInfo
    const hasRegleta =
      typeof backGLBInfo.regleta === 'number' &&
      typeof backGLBInfo.regletaMinimo === 'number' &&
      typeof backGLBInfo.regletaMaximo === 'number'

    if (hasRegleta) {
      morphed.push({
        default: backGLBInfo.regleta,
        _default: backGLBInfo.regleta,
        morphId: -1, // ID especial para regleta
        order: 999, // Al final
        type: 'R',
        min: backGLBInfo.regletaMinimo,
        max: backGLBInfo.regletaMaximo,
        name: 'Regleta',
        show: true,
        modifyable: true,
      })
    }

    return morphed.every(
      (el, i, arr) =>
        (el.name === 'Ancho' || el.name === 'Alto' || el.name === 'Fondo') && arr.length >= 3,
    )
      ? morphed
      : morphed.concat(
          Array.from(foundMorphs).map((el) => ({
            default: (backGLBInfo as any)[el.toLowerCase()] as number,
            _default: (backGLBInfo as any)[el.toLowerCase()] as number,
            morphId: 0,
            order: 0,
            type: '',
            min: (backGLBInfo as any)[el.toLowerCase()] as number,
            max: (backGLBInfo as any)[el.toLowerCase()] as number,
            show: true,
            name: el,
            modifyable: false,
          })),
        )
  } else {
    return [
      {
        default: backGLBInfo.ancho ?? 0,
        _default: backGLBInfo.ancho ?? 0,
        morphId: 0,
        order: 0,
        min: backGLBInfo.ancho ?? 0,
        max: backGLBInfo.ancho ?? 0,
        name: 'Ancho',
        show: true,
        type: '',
        modifyable: Boolean(backGLBInfo.modificarAncho),
      },
      {
        default: backGLBInfo.alto ?? 0,
        _default: backGLBInfo.alto ?? 0,
        morphId: 0,
        order: 0,
        min: backGLBInfo.alto ?? 0,
        max: backGLBInfo.alto ?? 0,
        name: 'Alto',
        show: true,
        type: '',
        modifyable: Boolean(backGLBInfo.modificarAlto),
      },
      {
        default: backGLBInfo.fondo ?? 0,
        _default: backGLBInfo.fondo ?? 0,
        morphId: 0,
        order: 0,
        min: backGLBInfo.fondo ?? 0,
        max: backGLBInfo.fondo ?? 0,
        name: 'Fondo',
        show: true,
        type: '',
        modifyable: Boolean(backGLBInfo.modificarFondo),
      },
    ]
  }
}
